import * as z from 'zod'

import {buildEntrySchemaFor} from '../entry'
import {safeOptional} from '../../safe-optional'
import {FormFieldValidationSchema} from './formFieldValidation'

export const FormFieldTextAreaSchema = buildEntrySchemaFor('formFieldTextArea', {
  fields: z.lazy(() =>
    z.object({
      htmlName: z.string(),
      label: z.string(),
      placeholder: z.string().optional(),
      validations: safeOptional(z.array(FormFieldValidationSchema)),
    }),
  ),
})

type FormFieldTextArea = z.infer<typeof FormFieldTextAreaSchema>

export const isFormFieldTextArea = (value: unknown): value is FormFieldTextArea => {
  return FormFieldTextAreaSchema.safeParse(value).success
}
